import { router } from '@/router'

import { factoryStudioRoutes } from './router/factory-studio-routes'

export function appendFactoryStudioRoutes() {
  for (const route of factoryStudioRoutes) {
    // const l = router.resolve({ path: log.path })
    if (!router.hasRoute(route.name as string)) {
      console.log('[appendFactoryStudioRoutes] FactoryStudio installRouter')
      router.addRoute(route)
    }
  }
}
